import { interactedWithGuestCommsAction } from './actions';

export enum GuestCommsAnalyticsActionTypes {
  INTERACTED_WITH_GUEST_COMMS = '[Analytics] [Guest Comms] Interacted with Guest comms',
}

export type InteractedWithGuestCommsAction = ReturnType<typeof interactedWithGuestCommsAction>;
